import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/blog/[slug]/page.tsx");
